import type React from 'react';

import { useTranslation } from 'react-i18next';

import { BaseResultItem } from './base-result-item/BaseResultItem';
import type { TResultStatus } from '../../check-tag/CheckTag';
import { CheckTag } from '../../check-tag/CheckTag';

interface ImageModificationResultItemProps {
  result: number;
}

function ImageModificationResultItem({
  result,
}: ImageModificationResultItemProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <BaseResultItem
      label={t('checks:estimations.image_modification.title')}
      tag={(
        <CheckTag
          kind={result as TResultStatus}
          value={t('checks:estimations.image_modification.result', { context: result })}
        />
      )}
    />
  );
}

export { ImageModificationResultItem };
